import { ReactNode, useEffect } from "react"
import { useNavigate } from "react-router-dom"
import { useAuth } from "./AuthContext"
import { toast } from "react-toastify"

interface AdminComponentsGuardProps {
    children: ReactNode
}

/**
 * Wraps /admin/collections: redirects non-admins to /components and shows a toast.
 * Prevents blank or error pages.
 */
export function AdminComponentsGuard({ children }: AdminComponentsGuardProps) {
    const { user, loading } = useAuth()
    const navigate = useNavigate()
    const isAdmin = Boolean(user?.admin ?? user?.info?.admin)

    useEffect(() => {
        if (loading) return
        if (!isAdmin) {
            toast.info("Use the Collections page to manage your collections.", { autoClose: 5000 })
            navigate("/components", { replace: true })
        }
    }, [loading, isAdmin, navigate])

    if (loading) {
        return null
    }
    if (!isAdmin) {
        return null
    }
    return <>{children}</>
}
